import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class PopularPagesService extends BaseService {
  constructor() {
    super(constants.FETCH_POPULAR_PAGES_DATA, 'PopularPagesService');
  }

  handleEvent(eventName, event) {
    return this.getClient('aiadmin').post(`/chatutility/popularPages`, event.payload);
  }

  handleResponse(response) {
    Framework.getStoreRegistry().getStore('popularPages').setResponse(response.data);
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    Framework.getStoreRegistry().getStore('popularPages').resetStoreValues();
  }
}
